module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAENSURBVGhD7Zg5DgJBDAT3H0AGPJ7jaSCOB4Cdtoy8hTA7gUuqsLwtyGZqmqZpmoCNeTIf5mthfcPZ3JmzWJsXMzq2pL7Jt6UczejACB7MlKcZxSN4N1M0Whq8BwfF4D04ELRXKbjHgaC9SsE9DgTtVQrucSBor1Jwj4Ni8B4cFIP34KAYvAcHxeA9GoxmShSNZEoUjWRKFI1kCg6KwXtwUAzegwNBe5WCexwI2qsU3ONA0F6l4B4HgvYqBfc4KAbvwUExeA8OisF7cFAM3jPCe+gnZz1s+UNqFI+gPzin7M2rGR1YUt+0NWexMv0h1f+y6Ng/vZn+y88er+jBan7+vZ8fTPj395qmab5mmt4JLL8REDhSsAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bureau/dark/48.png
// module id = 1903
// module chunks = 2